


export function delay(ms : number) : Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
}




// WEBPACK FOOTER //
// ./~/kea-react/src/async.tsx